import {Component, ElementRef, EventEmitter, Input, OnChanges, Output, ViewChild} from '@angular/core';
import {OneMonthFreeMode} from "../../one-month-free.component";

@Component({
    selector: 'db-one-month-free-editor-banner',
    templateUrl: './one-month-free-editor-banner.component.html',
    styleUrls: ['./one-month-free-editor-banner.component.scss'],
    standalone: false
})
export class OneMonthFreeEditorBannerComponent implements OnChanges {

  @ViewChild('builderVideo') builderVideo: ElementRef<HTMLVideoElement>;
  @Input() isAgency: boolean = false;
  @Input() mode: OneMonthFreeMode;
  @Input() videoPoster?: string = 'assets/images/backgrounds/builder_video_frame.jpg';
  @Input() videoSrc?: string = 'assets/videos/builder_video.mp4';
  @Output() onClose = new EventEmitter<void>();

  public loadVideo: boolean;

  ngOnChanges(): void {
    this.loadVideo = true;
    this.playVideo();
  }

  public playVideo(): void {
    if (this.mode !== 'editor') {
      this.builderVideo && this.builderVideo.nativeElement.setAttribute('loop', 'true');
    }
    setTimeout(() => {
      !!this.loadVideo && this.builderVideo && this.builderVideo.nativeElement.load();
      !!this.loadVideo && this.builderVideo && this.builderVideo.nativeElement.play();
      this.loadVideo = false;
    }, 500);
  }

}
